<mat-dialog-content class="text-center">
    <h5 mat-dialog-title class="offers-title">Sending Offers</h5>
    <p>Are you sure that you want to send offers for {{ data.programType }}?</p>
    <div class="content">
        <div class="amount-field" data-pw="amount-field-offered" data-qa="amount-field-offered">
            <div class="amount" data-pw="amount-offered" data-qa="amount-offered">
                {{ (data.totalFunding| currency:'USD':'symbol':'1.0-0') ?? '-' }}
            </div>
            <p class="amount-label" data-pw="amount-offered-label" data-qa="amount-offered-label">Amount of offers that
                shall be sent</p>
        </div>
        <div class="amount-field" data-pw="amount-field-awards" data-qa="amount-field-awards">
            <div class="amount" data-pw="amount-awards" data-qa="amount-awards">
                {{ data.numberOfAwards ?? '-' }}
            </div>
            <p class="amount-label" data-pw="amount-awards-label" data-qa="amount-awards-label">Number of Awards that
                will be sent</p>
        </div>
        <div class="amount-field" data-pw="remaining-funds-field" data-qa="remaining-funds-field">
            <div class="amount" data-pw="remaining-funds" data-qa="remaining-funds">
                {{ (data.remainingFunds| currency:'USD':'symbol':'1.0-0') ?? '-' }}
            </div>
            <p class="amount-label" data-pw="remaining-funds-label" data-qa="remaining-funds-label">Remaining Funds</p>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="center" class="mb-3">
    <button mat-stroked-button color="primary" [mat-dialog-close]="false" class="close-button secondary_materials_button xsmall_button" (click)="onCloseDialog()">Cancel</button>
    <button mat-stroked-button color="primary" [mat-dialog-close]="true" class="primary_materials_button xsmall_button" (click)="onConfirmDialog()">Send Offers</button>
</mat-dialog-actions>